// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"14140b08460609115609","655":"aaa377e419d2ffc9accc"}[chunkId] + ".js";
};